// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1653":"d7a43dfa","2616":"81f12457","6856":"8716c76a"}[chunkId] + ".chunk.css";
};